module.exports = __webpack_public_path__ + "static/media/kyle.728b8802.png";